import {ImageLoaderConfig} from "@angular/common";
import {createLogger} from "../logger/logger";

const logger = createLogger('AwsImageLoader');

export function awsImageLoader(config: ImageLoaderConfig): string {
    let {src, width, loaderParams} = config;

    // Extract parameters from loaderParams with defaults
    const height = loaderParams?.['height'] as number | undefined;
    const fit = loaderParams?.['fit'] as string | undefined;
    const format = loaderParams?.['format'] as string | undefined;
    const quality = loaderParams?.['quality'] as number | undefined;
    const greyscale = loaderParams?.['greyscale'] as boolean | undefined;
    const crop = loaderParams?.['crop'] as {
        width?: number;
        height?: number;
        left?: number;
        top?: number;
    } | undefined;
    const smartCrop = loaderParams?.['smartCrop'] as boolean | undefined;
    const roundCrop = loaderParams?.['roundCrop'] as boolean | undefined;
    const negate = loaderParams?.['negate'] as boolean | undefined;
    const tint = loaderParams?.['tint'] as { r?: number; g?: number; b?: number; } | undefined;
    const blur = loaderParams?.['blur'] as {
        sigma?: number;
        min?: number;
        max?: number;
    } | number | boolean | undefined;

    if (!src) return '';

    if (src.startsWith('images/')) return src;

    const isAbsoluteUrl = (url: string): boolean => /^https?:\/\//i.test(url);

    if (isAbsoluteUrl(src)) {
        try {
            const url = new URL(src);
            if (url.host === 'img.rooftopapp.com') {
                src = url.pathname.replace(/^\//, '');
            } else {
                return src;
            }
        } catch (e) {
            logger.error('Error parsing URL:', e);
        }
    }

    const baseUrl = 'https://img.rooftopapp.com/';
    const imageRequest: any = {
        bucket: "rt-backbone-img",
        key: src,
    };

    const edits: any = {};
    if (width || height || fit) {
        edits.resize = {
            ...(width ? {width} : {}),
            ...(height ? {height} : {}),
            fit: fit || 'cover',
        };
    }

    if (crop) edits.crop = crop;
    if (smartCrop) edits.smartCrop = true;
    if (roundCrop) edits.roundCrop = true;
    if (negate) edits.negate = true;
    if (format) edits.toFormat = format;
    if (quality) edits.quality = quality;
    if (greyscale) edits.greyscale = greyscale;
    if (tint) edits.tint = tint;
    if (blur) edits.blur = blur;

    if (Object.keys(edits).length > 0) {
        imageRequest.edits = edits;
    }

    const imageRequestJson = JSON.stringify(imageRequest);
    let base64Request: string;
    if (typeof btoa === 'function') {
        base64Request = btoa(imageRequestJson);
    } else if (typeof Buffer !== 'undefined') {
        base64Request = Buffer.from(imageRequestJson).toString('base64');
    } else {
        throw new Error('Base64 encoding is not supported in this environment.');
    }

    return `${baseUrl}${base64Request}`;
}
